import { useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
    Box,
    Button,
    Checkbox,
    Divider,
    FormControl,
    FormControlLabel,
    FormHelperText,
    Grid,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Stack,
    Typography,
    useMediaQuery,

} from '@mui/material';

// third party
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Link } from 'react-router-dom';
// project imports
import useScriptRef from '../../Hooks/useScriptRef';

import { useNavigate } from 'react-router-dom';
import AuthState from '../../Hooks/Authinctication.state';
// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import AuthCardWrapper from 'Component/AuthCardWrapper';
import AuthWrapper1 from 'Component/AuthWrapper1';


import { ToastContainer } from 'react-toastify';
const ForgotPassword = ({ ...others }) => {
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('md'));

    const [checked, setChecked] = useState(true);
    const navigate = useNavigate()
    const { formBusy, UserForgotPassword } = AuthState()
    const googleHandler = async () => {
        console.error('Login');
    };

    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
        <>
            <ToastContainer />
            <AuthWrapper1>
                <Grid container direction="column" justifyContent="flex-end" sx={{ minHeight: '100vh' }} className='login-background' >
                    <Grid item xs={12}>
                        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: 'calc(100vh - 68px)' }}>
                            <Grid item sx={{ m: { xs: 1, sm: 3 }, mb: 0 }}>
                                <AuthCardWrapper>
                                    <Grid container spacing={2} alignItems="center" justifyContent="center">

                                        <Grid item xs={12}>
                                            <Grid container direction={matchDownSM ? 'column-reverse' : 'row'} alignItems="center" justifyContent="center">
                                                <Grid item>
                                                    <Stack alignItems="center" justifyContent="center" spacing={1}>
                                                        <Typography color={"#92c323"} gutterBottom variant={matchDownSM ? 'h5' : 'h4'}>
                                                            Forgot Password
                                                        </Typography>
                                                    </Stack>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid container direction="column" justifyContent="center" spacing={2}>

                                                <Grid item xs={12} container alignItems="center" justifyContent="center">
                                                    <Box sx={{ mb: 2 }}>
                                                        <Typography variant="subtitle1"> Enter email address for forgot password </Typography>
                                                    </Box>
                                                </Grid>
                                            </Grid>

                                            <Formik
                                                initialValues={{
                                                    email: '',
                                                    submit: null
                                                }}
                                                validationSchema={Yup.object().shape({
                                                    email: Yup.string().email('Must be a valid email').max(255).required('Email is required')
                                                })}
                                                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                                                    try {
                                                        console.log("dat...", values)
                                                        const data = {
                                                            email: values.email,
                                                            
                                                        }
                                                        UserForgotPassword(data)
                                                        if (scriptedRef.current) {
                                                            setStatus({ success: true });
                                                            setSubmitting(false);
                                                            const data = {
                                                                email: values.email,
                                                               
                                                            }
                                                            UserForgotPassword(data)

                                                        }
                                                    } catch (err) {
                                                        console.error(err);
                                                        if (scriptedRef.current) {
                                                            setStatus({ success: false });
                                                            setErrors({ submit: err.message });
                                                            setSubmitting(false);

                                                        }
                                                    }
                                                }}
                                            >
                                                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, submitForm, touched, values }) => (
                                                    <form noValidate  {...others}>
                                                        <FormControl fullWidth error={Boolean(touched.email && errors.email)}   >
                                                            <InputLabel htmlFor="outlined-adornment-email-login">Email Address / Username</InputLabel>
                                                            <OutlinedInput
                                                                id="outlined-adornment-email-login"
                                                                type="email"
                                                                value={values.email}
                                                                name="email"
                                                                onBlur={handleBlur}
                                                                onChange={handleChange}
                                                                label="Email Address / Username"
                                                                inputProps={{}}
                                                            />
                                                            {touched.email && errors.email && (
                                                                <FormHelperText error id="standard-weight-helper-text-email-login">
                                                                    {errors.email}
                                                                </FormHelperText>
                                                            )}
                                                        </FormControl>



                                                        {errors.submit && (
                                                            <Box sx={{ mt: 3 }}>
                                                                <FormHelperText error>{errors.submit}</FormHelperText>
                                                            </Box>
                                                        )}
                                                        

                                                        <Box sx={{ mt: 2 }}>

                                                            <Button onClick={submitForm} sx={{backgroundColor:"#92c323",'&:hover':{backgroundColor:"#76a521"}}} disableElevation disabled={formBusy} fullWidth size="large" variant="contained" color="secondary">
                                                                {formBusy ? "Please wait...." : "Submit"}
                                                            </Button>

                                                        </Box>
                                                        <Box mt={2} textAlign={"center"}  >
                                                            <Link style={{color:'#92c323'}} to='/driver_forms/login' >Back to Login</Link>
                                                        </Box>
                                                    </form>
                                                )}
                                            </Formik>
                                        </Grid>
                                    </Grid>
                                </AuthCardWrapper>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </AuthWrapper1>
        </>
    );
};

export default ForgotPassword;
